function getCookieCulturebyName(name) {
    if (name === '_cultureSetting') {

        var pair = document.cookie.match(new RegExp(name + '=([^;]+)'));
        var lang = !!pair ? pair[1] : null;
        if (lang === null) {
            //var culture = getDefaultLangFromWebconfig();

            setCookie('_cultureSetting', 'fa-IR', 365);
            return "fa";
        } else {
            return lang.split('-')[0];
        }
    }
    return null;
};
function checkCookie(name) {
    try {
        var cookieName = getCookie(name);
        if (cookieName != "") {
            return true;
        } else {
            return false;
        }
    } catch (e) {
        return null;
    }
}
function getCookie(cname) {
    try {
        var name = cname + "=";
        //console.log('document.cookie', document.cookie);
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) === ' ') c = c.substring(1);
            if (c.indexOf(name) === 0) return c.substring(name.length, c.length);
        }
        return "";

    } catch (e) {
        return null;
    }
}

function setCookie(name, value, days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

function CheckURLforCulture() {
    var cultureWebConfig = ($('#CultureWebConfig').val() + "").split('-')[0];
    var cultureCookie = getCookieCulturebyName('_cultureSetting');
    var culture = ['fa', 'en', 'tr', 'ar', 'fr', 'de', 'pt', 'es', 'ba'];
    var urlSplit = cultureCookie;
    if (urlSplit == null || urlSplit === "") {
        urlSplit = cultureCookie;
    }
    if ((culture.indexOf(urlSplit) > -1)) {
        if (cultureWebConfig === cultureCookie) {
            return null;
        }
        return urlSplit;
    }
    //example = href=> localhost/flight/
    else {
        if (cultureWebConfig === cultureCookie) {
            return null;
        }
        return cultureCookie;
    }
}

function SetUrlWithCulture(url) {
    var culture = CheckURLforCulture();
    if (culture !== null) {
        return "/" + culture + url;
    }
    return url;
}

